import SvgColor from '../../../components/svg-color';
import { PATH_DASHBOARD } from '../../../routes/paths';
import { PERMISSIONS, ROLES } from '../../../utils/permissions';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  blog: icon('ic_blog'),
  cart: icon('ic_cart'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

const generateBulkPath = () => {
  console.log('actualisation de la navigation');

  return `https://bulk.mdp-distri.com?act=${localStorage.getItem(
    'accessToken'
  )}&siteId=${localStorage.getItem('siteId')}`;
};

export const navConfig = () => [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    permission: PERMISSIONS.dashboardView,
    items: [
      {
        title: 'home',
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard,
      },
      //{ title: 'ecommerce', path: PATH_DASHBOARD.general.ecommerce, icon: ICONS.ecommerce },
      // { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics },
      //{ title: 'banking', path: PATH_DASHBOARD.general.banking, icon: ICONS.banking },
      //{ title: 'booking', path: PATH_DASHBOARD.general.booking, icon: ICONS.booking },
      //{ title: 'file', path: PATH_DASHBOARD.general.file, icon: ICONS.file },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'management',
    items: [
      // E-COMMERCE
      {
        title: 'products',
        path: PATH_DASHBOARD.eCommerce.root,
        icon: ICONS.ecommerce,
        permission: PERMISSIONS.productList,
        children: [
          // { title: 'list', path: PATH_DASHBOARD.eCommerce.productsList },
          // { title: 'Stock', path: PATH_DASHBOARD.eCommerce.productsList },
          { title: 'locations', path: PATH_DASHBOARD.eCommerce.locations.list },
          { title: 'stocks', path: PATH_DASHBOARD.eCommerce.stocks },
        ],
      },
      {
        title: 'orders',
        path: PATH_DASHBOARD.orders.ordersList,
        icon: ICONS.invoice,
        permission: PERMISSIONS.orderList,
        // children: [
        // { title: 'list', path: PATH_DASHBOARD.orders.ordersList },
        // { title: 'devis', path: PATH_DASHBOARD.eCommerce.ordersList },
        // { title: 'bon de commande', path: PATH_DASHBOARD.eCommerce.ordersList },
        // ],
      },
      {
        title: 'customersPage.navTitle',
        path: PATH_DASHBOARD.customers.list,
        permission: PERMISSIONS.customerList,
        icon: ICONS.user,
      },
      // {
      //   title: 'websites',
      //   path: PATH_DASHBOARD.site.root,
      //   icon: ICONS.external,
      //   permission: PERMISSIONS.siteList,
      //   children: [
      //     { title: 'myWebsite', path: 'https://www.flashvideofilm.fr/' },
      //     { title: 'mdpOrder', path: PATH_DASHBOARD.site.order },
      //   ],
      // },
      /*{
        title: 'maintenance',
        path: PATH_DASHBOARD.eCommerce.root,
        icon: ICONS.mail,
        children: [
          { title: 'Ticket', path: PATH_DASHBOARD.eCommerce.ordersList },
        ],
      },*/

      // INVOICE
      /*{
        title: 'invoice',
        path: PATH_DASHBOARD.invoice.root,
        icon: ICONS.invoice,
        children: [
          { title: 'list', path: PATH_DASHBOARD.invoice.list },
          { title: 'details', path: PATH_DASHBOARD.invoice.demoView },
          { title: 'create', path: PATH_DASHBOARD.invoice.new },
          { title: 'edit', path: PATH_DASHBOARD.invoice.demoEdit },
        ],
      },

      // BLOG
      {
        title: 'blog',
        path: PATH_DASHBOARD.blog.root,
        icon: ICONS.blog,
        children: [
          { title: 'posts', path: PATH_DASHBOARD.blog.posts },
          { title: 'post', path: PATH_DASHBOARD.blog.demoView },
          { title: 'create', path: PATH_DASHBOARD.blog.new },
        ],
      },
      {
        title: 'File manager',
        path: PATH_DASHBOARD.fileManager,
        icon: ICONS.folder,
      },*/
    ],
  },

  {
    subheader: 'websites',
    permission: PERMISSIONS.siteList,
    items: [
      {
        title: 'myWebsite',
        path: localStorage.getItem('siteUrl') || '',
        icon: ICONS.external,
      },
      {
        title: 'mdpOrder',
        path: PATH_DASHBOARD.site.order,
        icon: ICONS.cart,
      },
    ],
  },

  {
    subheader: 'application',
    permission: PERMISSIONS.dashboardView,
    items: [
      {
        title: 'applications',
        path: PATH_DASHBOARD.applications.root,
        permission: PERMISSIONS.dashboardView,
        icon: ICONS.label,
        children: [
          {
            title: 'upComingAppsPage.web.navTitle',
            path: PATH_DASHBOARD.applications.web,
          },
          {
            title: 'upComingAppsPage.sale.navTitle',
            path: PATH_DASHBOARD.applications.sales,
          },
          {
            title: 'upComingAppsPage.finance.navTitle',
            path: PATH_DASHBOARD.applications.finance,
          },
          {
            title: 'upComingAppsPage.inventory.navTitle',
            path: PATH_DASHBOARD.applications.inventory,
          },
          {
            title: 'upComingAppsPage.marketing.navTitle',
            path: PATH_DASHBOARD.applications.marketing,
          },
          {
            title: 'upComingAppsPage.hr.navTitle',
            path: PATH_DASHBOARD.applications.hr,
          },
          {
            title: 'upComingAppsPage.services.navTitle',
            path: PATH_DASHBOARD.applications.services,
          },
          {
            title: 'upComingAppsPage.productivity.navTitle',
            path: PATH_DASHBOARD.applications.productivity,
          },
        ],
      },
      // {
      //   title: 'upComingApps',
      //   path: PATH_DASHBOARD.upComingApps,
      //   icon: ICONS.calendar,
      // },
      {
        title: 'bulk',
        permission: PERMISSIONS.dashboardView,
        path: generateBulkPath(),
        icon: ICONS.label,
      },
      //{ title: 'ecommerce', path: PATH_DASHBOARD.general.ecommerce, icon: ICONS.ecommerce },
      // { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics },
      //{ title: 'banking', path: PATH_DASHBOARD.general.banking, icon: ICONS.banking },
      //{ title: 'booking', path: PATH_DASHBOARD.general.booking, icon: ICONS.booking },
      //{ title: 'file', path: PATH_DASHBOARD.general.file, icon: ICONS.file },
    ],
  },
  {
    subheader: 'settings',
    items: [
      // USER
      {
        title: 'apeLinkPage.navTitle',
        path: PATH_DASHBOARD.apeLinkPage,
        icon: ICONS.file,
        roles: ['ADMIN'],
        permission: ROLES.ADMIN,
      },
      {
        title: 'publicationsLinkPage.navTitle',
        path: PATH_DASHBOARD.publicationsLinkPage,
        icon: ICONS.file,
        roles: ['ADMIN'],
        permission: ROLES.ADMIN,
      },
      {
        title: 'locationLinkPage.navTitle',
        path: PATH_DASHBOARD.locationsLinkPage,
        icon: ICONS.file,
        roles: ['ADMIN'],
        permission: ROLES.ADMIN,
      },
      {
        title: 'userListPage.navTitle',
        path: PATH_DASHBOARD.user.list,
        icon: ICONS.user,
        roles: ['ADMIN'],
        permission: PERMISSIONS.userList,
      },
      {
        title: 'companyListPage.navTitle',
        path: PATH_DASHBOARD.companies.list,
        icon: ICONS.folder,
        roles: ['ADMIN'],
        permission: ROLES.ADMIN,
      },
      {
        title: 'supportListPage.navTitle',
        path: 'https://crm.mdp-distri.com/helpdesk/service-clientele-1',
        icon: ICONS.chat,
        // children: [{ title: 'Ticket', path: PATH_PAGE.comingSoon }],
      },
    ],
  },

  // APP
  // ----------------------------------------------------------------------
  /*{
    subheader: 'app',
    items: [
      {
        title: 'mail',
        path: PATH_DASHBOARD.mail.root,
        icon: ICONS.mail,
        info: <Label color="error">+32</Label>,
      },
      {
        title: 'chat',
        path: PATH_DASHBOARD.chat.root,
        icon: ICONS.chat,
      },
      {
        title: 'calendar',
        path: PATH_DASHBOARD.calendar,
        icon: ICONS.calendar,
      },
      {
        title: 'kanban',
        path: PATH_DASHBOARD.kanban,
        icon: ICONS.kanban,
      },
    ],
  },*/

  // DEMO MENU STATES
  /*{
    subheader: 'Other cases',
    items: [
      {
        // default roles : All roles can see this entry.
        // roles: ['user'] Only users can see this item.
        // roles: ['admin'] Only admin can see this item.
        // roles: ['admin', 'manager'] Only admin/manager can see this item.
        // Reference from 'src/guards/RoleBasedGuard'.
        title: 'item_by_roles',
        path: PATH_DASHBOARD.permissionDenied,
        icon: ICONS.lock,
        roles: ['admin'],
        caption: 'only_admin_can_see_this_item',
      },
      {
        title: 'menu_level',
        path: '#/dashboard/menu_level',
        icon: ICONS.menuItem,
        children: [
          {
            title: 'menu_level_2a',
            path: '#/dashboard/menu_level/menu_level_2a',
          },
          {
            title: 'menu_level_2b',
            path: '#/dashboard/menu_level/menu_level_2b',
            children: [
              {
                title: 'menu_level_3a',
                path: '#/dashboard/menu_level/menu_level_2b/menu_level_3a',
              },
              {
                title: 'menu_level_3b',
                path: '#/dashboard/menu_level/menu_level_2b/menu_level_3b',
                children: [
                  {
                    title: 'menu_level_4a',
                    path: '#/dashboard/menu_level/menu_level_2b/menu_level_3b/menu_level_4a',
                  },
                  {
                    title: 'menu_level_4b',
                    path: '#/dashboard/menu_level/menu_level_2b/menu_level_3b/menu_level_4b',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        title: 'item_disabled',
        path: '#disabled',
        icon: ICONS.disabled,
        disabled: true,
      },

      {
        title: 'item_label',
        path: '#label',
        icon: ICONS.label,
        info: (
          <Label color="info" startIcon={<Iconify icon="eva:email-fill" />}>
            NEW
          </Label>
        ),
      },
      {
        title: 'item_caption',
        path: '#caption',
        icon: ICONS.menuItem,
        caption:
          'Quisque malesuada placerat nisl. In hac habitasse platea dictumst. Cras id dui. Pellentesque commodo eros a enim. Morbi mollis tellus ac sapien.',
      },
      {
        title: 'item_external_link',
        path: 'https://www.google.com/',
        icon: ICONS.external,
      },
      {
        title: 'blank',
        path: PATH_DASHBOARD.blank,
        icon: ICONS.blank,
      },
    ],
  },*/
];

export default navConfig;
